import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/software/erp")({
  component: () => <Outlet />,
});
